(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jd-cart"]) return;
  try {
    
/* Quantity changes reload the cart page, so anything typed here is saved to
   the cart as soon as a field loses focus. Without this, editing a quantity
   after writing a message would silently discard the message. The form post
   remains the fallback if this request fails. */
(function () {
  var fields = document.querySelectorAll('.streamfields [name^="attributes["]');
  Array.prototype.forEach.call(fields, function (el) {
    el.addEventListener('blur', function () {
      var m = el.name.match(/^attributes\[(.+)\]$/);
      if (!m) return;
      var payload = { attributes: {} };
      payload.attributes[m[1]] = el.value;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
